export const adaptPantallasRI = (pantalla) => {
    return {
        id: pantalla?.idPantallaRI,
        displayName: pantalla?.pantalla,
        modulos: pantalla?.idTipoModulo?.map(x => ({ id: x.idTipoModulo, displayName: x.abreviacion }))
    }
}

export const adaptPantallasRIArray = (
    pantallas
) => {
    return structuredClone(pantallas?.pantallasRI)
        ?.map(pantalla => adaptPantallasRI(pantalla));
}